// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textarea-field {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 24px;
}
.textarea-field.no-margin {
  margin-bottom: 0;
}
.textarea-field__label {
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 8px;
  width: fit-content;
}
.textarea-field__textarea {
  height: 156px;
  padding: 24px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}
.textarea-field__textarea::placeholder {
  font-family: "Open Sans" !important;
}
.textarea-field__textarea:focus {
  outline-color: #0abf53;
}
.textarea-field__icon {
  position: absolute;
  right: 16px;
  font-size: 24px;
  height: 24px;
  bottom: 14px;
  line-height: 24px;
  color: #0abf53;
}`, "",{"version":3,"sources":["webpack://./src/components/TextArea/TextArea.scss","webpack://./src/utils/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AADF;AAGE;EACE,gBAAA;AADJ;AAGE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AADJ;AAGE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAEI;EACM,mCAAA;AAAV;AAEI;EACE,sBC5BU;AD4BhB;AAGE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,cCtCY;ADqChB","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.textarea-field {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-bottom: 24px;\n\n  &.no-margin {\n    margin-bottom: 0;\n  }\n  &__label {\n    font-size: 16px;\n    font-weight: normal;\n    margin-bottom: 8px;\n    width:fit-content;\n  }\n  &__textarea {\n    height: 156px;\n    padding: 24px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 16px;\n    &::placeholder {\n          font-family: \"Open Sans\" !important;\n      }\n    &:focus {\n      outline-color: $primary-color;\n    }\n  }\n  &__icon {\n    position: absolute;\n    right: 16px;\n    font-size: 24px;\n    height: 24px;\n    bottom: 14px;\n    line-height: 24px;\n    color: $primary-color;\n  }\n}","$primary-color: #0abf53;\n\n// Screen size variables\n$screen-xxs-max: 370px; // Tiny phones\n$screen-xs-max: 425px; // Tiny phones\n$screen-sm-max: 576px; // Small tablets and large smartphones (landscape view)\n$screen-md-max: 767px; // Small tablets (portrait view)\n$screen-lg-max: 1024px; // Tablets and small desktops\n$screen-upper-lg-max: 1120px; // Tablets and small desktops\n$screen-xl-max: 1440px; // Large tablets and desktops\n\n// z-index\n$z-indexes: (\"login\", \"loginFooter\", \"loginOverlay\");\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
